/* TrendoraHub motion: scroll reveals, card tilt, cursor glow, scroll progress. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('th-js');

  var REVEAL = [
    '.th-head', '.th-cat', '.th-benefit', '.th-quote', '.th-love__item', '.th-steps li',
    '.th-faq details', '.th-promo', '.th-season__copy', '.th-season__media', '.th-spot__media',
    '.th-spot__info', '.th-news > *', '.th-mini', '.th-page-hero .th-wrap > *', '.th-rte > *',
    '.th-footer__top > *', 'product-card'
  ].join(',');

  var io = !reduce && 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;

  function prepare(root) {
    if (!io) return;
    (root || document).querySelectorAll(REVEAL).forEach(function (el) {
      if (el.classList.contains('th-reveal') || el.closest('.th-cover')) return;
      var parent = el.parentElement;
      var index = 0;
      if (parent) {
        var sibs = parent.children;
        for (var i = 0; i < sibs.length; i++) { if (sibs[i] === el) break; if (sibs[i].matches(REVEAL)) index++; }
      }
      el.style.setProperty('--th-d', Math.min(index, 6) * 0.07 + 's');
      el.classList.add('th-reveal');
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92 && r.bottom > 0) {
        requestAnimationFrame(function () { el.classList.add('is-in'); });
      } else {
        io.observe(el);
      }
    });
  }

  function tilt(root) {
    if (reduce || !window.matchMedia('(pointer: fine)').matches) return;
    (root || document).querySelectorAll('.th-cat:not([data-th-tilt])').forEach(function (card) {
      card.setAttribute('data-th-tilt', '');
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--th-ry', (x * 8).toFixed(2) + 'deg');
        card.style.setProperty('--th-rx', (y * -8).toFixed(2) + 'deg');
      });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--th-ry', '0deg');
        card.style.setProperty('--th-rx', '0deg');
      });
    });
  }

  function glow(root) {
    (root || document).querySelectorAll('.th-season, .th-section--ink, .th-spot--dark').forEach(function (band) {
      if (band.classList.contains('th-glow')) return;
      band.classList.add('th-glow');
      if (reduce) return;
      band.addEventListener('pointermove', function (e) {
        var r = band.getBoundingClientRect();
        band.style.setProperty('--th-mx', (e.clientX - r.left) + 'px');
        band.style.setProperty('--th-my', (e.clientY - r.top) + 'px');
      });
    });
  }

  function progress() {
    if (reduce || document.querySelector('.th-progress')) return;
    var bar = document.createElement('div');
    bar.className = 'th-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      ticking = false;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--th-progress', h > 0 ? (window.scrollY / h).toFixed(4) : 0);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function init(root) { prepare(root); tilt(root); glow(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); progress(); });
  } else { init(); progress(); }

  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; init(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();